import React from 'react'
import { Routes, Route } from 'react-router-dom';
import List from './List';
import Details from './Details';
import AddEdit from './AddEdit';
import Duplicate from './Duplicate';

function ProductGroup() {

  return (
    <>
      <Routes>
        <Route path="/" element={<List />} />
        
        <Route path="details/:id" element={<Details />} />
        <Route path="new" element={<AddEdit />} />
        <Route path="duplicate" element={<Duplicate />} />
        <Route path="edit/:id" element={<AddEdit />} />
      </Routes>
    </>
  );
}

export default ProductGroup;
